var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 53,
    viewBox: "0 0 114 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.15,
    d: "M56.807 96.4382C88.1462 96.4382 113.552 75.0165 113.552 48.5914C113.552 22.1664 88.1462 0.744629 56.807 0.744629C25.4679 0.744629 0.0625 22.1664 0.0625 48.5914C0.0625 75.0165 25.4679 96.4382 56.807 96.4382Z",
    fill: "url(#paint0_radial_11_76)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11_76",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.807 48.5914) scale(56.7445 47.8468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#854229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector-3.94efda44619684c45012390fd144edba.svg";
export { ForwardRef as ReactComponent };